export const translateCategorySlug = (
    t: (k: string) => string,
    name: string,
    description?: string
): string => {
    if (!name) return "";
    const key = `timesheet_page.categories_slug.${name}`;
    const translated = t(key);
    if (translated && translated !== key) return translated;
    return description ? `${name}_${description}` : name;
};
